import React from "react";
import { Modal } from "react-bootstrap";
import { CircleLoading } from "../../Assets/Icons";

const ConfirmBox = ({
  showModal,
  onHide,
  onActionClick = () => {},
  alertMessage,
  clickLoading = false,
  actionButtonItem,
  alertTitle,
}) => {
  const handleActionClick = () => {
    if (onActionClick) {
      onActionClick();
    }
  };

  return (
    <Modal className="confirm-modal" show={showModal} onHide={onHide} centered={true}>
      <div className="confirm-box">
        <h6>{alertTitle}</h6>
        <p> {alertMessage} </p>
        <div className="modal-footer">
          <button className="cancel" onClick={onHide}>
            Cancel
          </button>
          <button className="save" onClick={handleActionClick}>
            {!clickLoading ? (
              actionButtonItem
            ) : (
              <div className="loading-button">
                <CircleLoading />
              </div>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmBox;
